import React from "react";
import styled from "styled-components";
import Header from "./Header";
import AdminShortcut from "../common/AdminShortcut";

const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  width: 100%;
  padding-top: 100px; /* Account for fixed header height */

  @media (max-width: 768px) {
    padding-top: 80px; /* Smaller header on mobile */
  }
`;

const Layout = ({ children }) => {
  return (
    <LayoutContainer>
      <Header />
      <Main>{children}</Main>
      <AdminShortcut />
    </LayoutContainer>
  );
};

export default Layout;
